const originalFetch = window.fetch;

window.fetch = function (...args) {
  const url = args[0];
  const isCartEndpoint = typeof url === 'string' &&
    ['/cart/add.js', '/cart/update.js', '/cart/change.js'].some(path => url.includes(path));

  if (isCartEndpoint) {
    const stack = new Error().stack || '';
    const isFromConsole = stack.includes('at <anonymous>') || stack.includes('VM');
    if (isFromConsole) {
      return Promise.reject('Blocked');
    }
  }

  // After external /cart/add.js calls (e.g. PDP form, GFB bundles), refresh the cartx drawer
  const isCartAdd = typeof url === 'string' && url.includes('/cart/add.js');
  if (isCartAdd) {
    return originalFetch.apply(this, args).then(function (response) {
      const cloned = response.clone();
      cloned.json().then(function () {
        if (!isProcessing) {
          fetchCart();
          document.querySelector('.cartx-add-to-cart-popup')?.classList.remove('hide');
          hideCartOpenTost();
          openDrawer(new Event('click'));
        }
      }).catch(function () {});
      return response;
    });
  }

  return originalFetch.apply(this, args);
};

let freeGiftPrice = 100;
let priceArray= [0,1];
let currentDiscountCodes = [];
var user_cart = null;
let isProcessing = false;
let showConfetti = false;
const invalidFreebieVariants = new Set();
const shopifyStorefrontApiUrl =
  "https://devx-cartx.myshopify.com/api/2025-01/graphql.json";
const shopifyStorefrontToken = "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";
if (window.location.pathname !== "/cart") {
  fetchCart();
}

function fetchCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      user_cart = cart;
      cartx();
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

function bindingEvent() {
  document
    .querySelectorAll(".cartx-drawer-product-quantity-button")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const isDeleteBtn = button.classList.contains("cartx-item-delete-btn");
        const eventName = button.getAttribute("name");

        if (!isDeleteBtn && eventName !== "plus" && eventName !== "minus") return;

        const li = event.target.closest("li.cartx-drawer-product-item");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        if (isDeleteBtn) {
          const input = li.querySelector(".cartx-drawer-product-quantity-input");
          const fullQty = input ? parseInt(input.value) || 1 : 1;

          const variantObject = {
            [variantId]: {
              quantity: fullQty,
              price: parseInt(li.getAttribute("data-price")) || 0,
              type: li.getAttribute("data-product-type") || "",
            },
          };
          cartx(variantObject, "REMOVE");
          return;
        }

        const variantObject = {
          [variantId]: {
            quantity: parseInt(li.getAttribute("data-quantity")) || 0,
            price: parseInt(li.getAttribute("data-price")) || 0,
            type: li.getAttribute("data-product-type") || "",
          },
        };

        switch (eventName) {
          case "plus":
            cartx(variantObject, "ADD");
            break;
          case "minus":
            cartx(variantObject, "REMOVE");
            break;
        }
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "CLAIM_ADD");
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-remove-from-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "CLAIM_REMOVE");
      });
    });

  document.querySelectorAll(".code-copy-btn").forEach(function (button) {
    button.addEventListener("click", function () {
      const valueToCopy = this.getAttribute("data-code");

      if (valueToCopy) {
        // Copy to clipboard
        const tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = valueToCopy;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        // Show popup message with animation
        const popup = document.createElement("div");
        popup.className = "copy-popup";
        popup.textContent = "Copied successfully!";
        document.body.appendChild(popup);

        popup.style.position = "fixed";
        popup.style.bottom = "-50px";
        popup.style.left = "50%";
        popup.style.transform = "translateX(-50%)";
        popup.style.opacity = 0;
        popup.style.transition = "all 0.3s ease";

        // Force reflow to apply transition
        void popup.offsetHeight;

        // Animate in
        popup.style.bottom = "70px";
        popup.style.opacity = 1;
        setTimeout(function () {
          popup.style.transition = "all 0.3s ease";
          popup.style.bottom = "0px";
          popup.style.opacity = "0";

          setTimeout(function () {
            popup.remove();
          }, 300);
        }, 1000);
      }
    });
  });

  document.querySelectorAll(".cartx-empty-upsell").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const variantId = button.getAttribute("data-variant-id");
      if (!variantId) return;

      const variantObject = {
        [variantId]: {
          quantity: parseInt(button.getAttribute("data-quantity")) || 0,
          price: parseInt(button.getAttribute("data-price")) || 0,
          type: button.getAttribute("data-product-type") || "",
        },
      };

      cartx(variantObject, "ADD");
    });
  });

  document.querySelectorAll(".prv-submit-button").forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.closest(".prv-coupon-input-container").querySelector(
        ".prv-coupon-input"
      );
      applyCode(input);
    });
  });

  document.querySelectorAll(".prv-coupon-input").forEach((input) => {
    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        applyCode(input);
      }
    });
  });

  if (document.getElementById("cartx-remove-btn") !== null) {
    document
      .getElementById("cartx-remove-btn")
      .addEventListener("click", function () {
        const code = this.getAttribute("data-discount-code");

        removeDiscount(user_cart?.token, code);
      });
  }

  const slider = document.getElementById("cartx-claim-product-list");
  const progress = document.getElementById("scrollProgress");

  if (slider && progress) {
    slider.addEventListener("scroll", () => {
      const scrollLeft = slider.scrollLeft;
      const scrollWidth = slider.scrollWidth - slider.clientWidth;
      const scrolledPercent = (scrollLeft / scrollWidth) * 100;
      progress.style.width = `${scrolledPercent}%`;
    });
  }

  document
    .querySelectorAll(".cartx-variant-cart")
    .forEach(function (selector) {
      
      selector.addEventListener("change", function (event) {
        const selectedOption = event.target.selectedOptions[0];
        const selectedVariantId = selectedOption.value;
        const variantPrice = selectedOption.getAttribute("data-price");
        const quantity = selectedOption.getAttribute("data-quantity");
        const type = selectedOption.getAttribute("data-product-type");
        const finalPrice = selectedOption.getAttribute("data-final-price");

        const li = event.target.closest("li");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [selectedVariantId]: {
            quantity: Number(quantity),
            replace_variant: variantId,
            price: variantPrice,
            type:type,
            final_price:finalPrice
          },
        };

        cartx(variantObject, "ADD");
      });
    });

    document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);
    
      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

  const viewAllBtn = document.querySelector(".prv-view-all");
  const closeBtn = document.querySelector(".cartx-offer-close");
  const offerPanel = document.querySelector(".cartx-all-offers");

  if (viewAllBtn && offerPanel) {
    viewAllBtn.addEventListener("click", function () {
      offerPanel.classList.add("is--visible");
    });
  }

  if (closeBtn && offerPanel) {
    closeBtn.addEventListener("click", function () {
      offerPanel.classList.remove("is--visible");
    });
  }

  const signinBtn = document.getElementById("cartx-signin-btn");
  if (signinBtn) {
    signinBtn.addEventListener("click", function (event) {
      event.preventDefault();
      window.location.href = "/account";
    });
  }

  const applyButtons = document.querySelectorAll(".cartx-apply-button-wrapper");
  if (applyButtons.length > 0) {
    applyButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        applyDiscount(user_cart?.token, couponCode);
      });
    });
  }

  const removeButtons = document.querySelectorAll(
    ".cartx-remove-button-wrapper:not(.cartx-auto-discount-remove)"
  );
  if (removeButtons.length > 0) {
    removeButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        const couponCode = this.getAttribute("data-code");
        removeDiscount(user_cart?.token, couponCode);
      });
    });
  }

  
  document.querySelectorAll('.shipping-info-toggle').forEach(function (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      const infoBox = document.querySelector('.shipping-info-content');
      if (!infoBox) return;
      infoBox.classList.toggle('open');
      toggleBtn.setAttribute('aria-expanded', infoBox.classList.contains('open'));
    });
  });

  initPincodeInput();
  
  loadedEvents();
}

function handleVariantChange(event) {
  
  const selectedOption = event.target.selectedOptions[0];
  const selectedVariantId = selectedOption.value;
  const variantPrice = selectedOption.getAttribute("data-price");
  const type = selectedOption.getAttribute("data-product-type");
  const image = selectedOption.getAttribute("data-image");

  const li = event.target.closest(".cartx-upsell-product-item").querySelector('.cartx-product-button-wrap');
  if (!li) return;

  const formattedPrice = `₹ ${(parseInt(variantPrice) / 100).toFixed(2)}`;

  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-img').src = image;
  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-price .current-price').innerHTML = formattedPrice;
  li.setAttribute("data-variant-id", selectedVariantId);
  li.setAttribute("data-price", variantPrice);
  li.setAttribute("data-product-type", type);
}


function isValidIndianPincodeCart(pincode) {
  var pincodeInput = document.getElementById("pincode_input_cart");
  var expectedCart = document.querySelector(".cartx-drawer .expected_cart");
  pincodeInput.style.color = "#f00";
  expectedCart.textContent = "Enter a valid pincode";
  expectedCart.style.color = "#f00";
  // pincodeInput.style.borderColor = "#f00";
  document.querySelector(".cartx-verified-cart-svg").classList.remove('show-svg');
  // document.getElementById("verified_cart").style.display = "none";
  var regex = /^[1-9][0-9]{5}$/;
  return regex.test(pincode);
}

function getFormattedDate(date) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-IN", options);
}

function handlePincodeInputChangeCart() {
  var pincode = document.getElementById("pincode_input_cart").value;
  if (isValidIndianPincodeCart(pincode)) {
    localStorage.setItem("validPin", pincode);
    document.getElementById("pincode_input_cart").style.color = "green";
    // document.getElementById("pincode_input_cart").style.borderColor = "black";
    // document.getElementById("verified_cart").style.display = "block";

    var url = "https://neworder.plumgoodness.com/get-estimate-date";
    var data = JSON.stringify({ drop_pincode: pincode });

    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var result = JSON.parse(xhr.responseText);
        var expectedCart = document.querySelector(".cartx-drawer .expected_cart");

        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + parseInt(result.expects_max_date));
        // Adding 12 hours to the current time
        currentDate.setHours(currentDate.getHours());
        currentDate.setDate(currentDate.getDate() + 1);

        const formattedDate = getFormattedDate(currentDate);
        expectedCart.innerHTML = `Estimated Delivery Date <br> ${formattedDate}`;
        expectedCart.style.color = "green";
        document.querySelector(".cartx-verified-cart-svg").classList.add('show-svg');
      }
    };
    xhr.send(data);
  }
}

function getFormattedDate(date) {
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const weekday = date.toLocaleString('default', { weekday: 'long' });

  return `${day}${this.getDaySuffix(day)} ${month}, ${weekday}`;
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
      return 'th';
  }
  switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
  }
}

function initPincodeInput() {
  const inputField = document.getElementById("pincode_input_cart");
  if (!inputField) return;

  const storedPin = localStorage.getItem("validPin");
  if (storedPin) {
    inputField.value = storedPin;
    handlePincodeInputChangeCart(); // run immediately
  }

  inputField.addEventListener("keyup", handlePincodeInputChangeCart);
}

function startLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.add("loading");
  }
}

function stopLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.remove("loading");
  }
}

// UTM source capture and coupon filtering
(function () {
  var params = new URLSearchParams(window.location.search);
  var utmSource = params.get('utm_source');

  // Google Ads detection — gclid or gad_source means Google traffic
  if (!utmSource && (params.get('gclid') || params.get('gad_source'))) {
    utmSource = 'google';
  }

  // Check utm_medium for Google (e.g. Google-BrandSearch)
  if (!utmSource) {
    var utmMedium = params.get('utm_medium');
    if (utmMedium && utmMedium.toLowerCase().indexOf('google') !== -1) {
      utmSource = 'google';
    }
  }

  // Fallback: check inside currentFlow param (e.g. byob/?utm_source=Shiprocket)
  if (!utmSource) {
    var currentFlow = params.get('currentFlow');
    if (currentFlow) {
      var flowIdx = currentFlow.indexOf('utm_source=');
      if (flowIdx !== -1) {
        var rest = currentFlow.substring(flowIdx + 11);
        var endIdx = rest.indexOf('&');
        utmSource = endIdx !== -1 ? rest.substring(0, endIdx) : rest;
      }
    }
  }

  if (utmSource) {
    sessionStorage.setItem('cartx_utm_source', utmSource.toLowerCase());
  }
})();

function filterCouponsByUtm() {
  var storedUtm = sessionStorage.getItem('cartx_utm_source') || '';
  document.querySelectorAll('.prv-coupon-card').forEach(function (card) {
    var couponUtm = card.getAttribute('data-utm-source') || '';
    if (storedUtm) {
      card.style.display = (couponUtm === storedUtm) ? '' : 'none';
    } else {
      card.style.display = couponUtm ? 'none' : '';
    }
  });
}

// UTM-based cart section visibility (reads Site GWP utm overrides)
function applyUtmSectionOverrides() {
  var storedUtm = sessionStorage.getItem('cartx_utm_source') || '';
  if (!storedUtm) return;

  var overridesRaw = document.body.getAttribute('data-utm-overrides');
  if (!overridesRaw) return;

  try {
    var overrides = JSON.parse(overridesRaw);
    var match = null;
    for (var i = 0; i < overrides.length; i++) {
      if (overrides[i].utm_source && overrides[i].utm_source.toLowerCase() === storedUtm) {
        match = overrides[i];
        break;
      }
    }
    if (!match) return;

    // Hide/show progress bar
    if (match.disable_progress_bar) {
      document.querySelectorAll('.custom-progressbar').forEach(function (el) { el.style.display = 'none'; });
    }

    // Hide/show coupons section
    if (match.disable_coupons) {
      document.querySelectorAll('.cartx-offer-main-wrapper').forEach(function (el) { el.style.display = 'none'; });
    }

    // Hide/show recommendations
    if (match.disable_recommendations) {
      document.querySelectorAll('.cartx-mobile-recs.cartx-filled-mobile-recs').forEach(function (el) { el.style.display = 'none'; });
      document.querySelectorAll('.cartx-empty-sidebar.cartx-ai-upsell').forEach(function (el) { el.style.display = 'none'; });
    }

    // Hide/show freebies
    if (match.disable_freebies) {
      document.querySelectorAll('.cartx-freebies-card-wrap').forEach(function (el) { el.style.display = 'none'; });
    }
  } catch (e) {}
}

document.addEventListener("DOMContentLoaded", function () {
  filterCouponsByUtm();
  applyUtmSectionOverrides();
  // const recommendationsEl = document.querySelector("product-recommendations");

  // if (recommendationsEl) {
  //   const observer = new MutationObserver(() => {
  //     if (
  //       recommendationsEl.classList.contains("product-recommendations--loaded")
  //     ) {
  //       loadedEvents();

  //       observer.disconnect(); // stop observing once it's loaded
  //     }
  //   });

  //   observer.observe(recommendationsEl, { attributes: true });
  // }

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains("cartx-product-button-wrap")) {

          loadedEvents();
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  
  loadedEvents();
});

function handleAddToCartClick(event) {
  const button = event.currentTarget;

  // On PDP, let the native form submission handle ATC (supports GFB bundles, etc.)
  const productForm = button.closest('form[is="product-form"]');
  if (productForm) return;

  // Stop loader-button custom element from handling this click — cartx manages the flow
  event.preventDefault();
  event.stopImmediatePropagation();

  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  wrapper.classList.add("cartx-button-loadding");

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "ADD");
}

function handleRemoveFromCartClick(event) {
  const button = event.currentTarget;

  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  /* Trigger loader-button spinner on qty button (same visual as ATC) */
  var qtyLoaderBtn = wrapper.querySelector('.atc_with_qty[is="loader-button"]');
  if (qtyLoaderBtn) qtyLoaderBtn.setAttribute("aria-busy", "true");

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
    },
  };

  cartx(variantObject, "REMOVE");
}

function loadedEvents() { 
  
  document
    .querySelectorAll(".cartx-add-to-cart:not(.plus)")
    .forEach((button) => {
      
      button.removeEventListener("click", handleAddToCartClick);
      button.addEventListener("click", handleAddToCartClick);
    });

  document.querySelectorAll(".cartx-add-to-cart.plus").forEach((button) => {
    
    button.removeEventListener("click", handleAddToCartClick);
    button.addEventListener("click", handleAddToCartClick);
  });

  document
    .querySelectorAll(".cartx-remove-from-cart.minus")
    .forEach((button) => {
      
      button.removeEventListener("click", handleRemoveFromCartClick);
      button.addEventListener("click", handleRemoveFromCartClick);
    });

    document
    .querySelectorAll(".cartx-icon")
    .forEach((button) => {
      
      button.removeEventListener("click", openDrawer);
      button.addEventListener("click", openDrawer);
    });

    document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
      // Remove the previous event listener, if any
      selector.removeEventListener("change", handleVariantChange);
    
      // Add the new event listener
      selector.addEventListener("change", handleVariantChange);
    });

    document.querySelectorAll('.cartx-variant-switcher').forEach(function (selector) {
      selector.removeEventListener("click", handleVariantChangeQuantity);
      selector.addEventListener("click", handleVariantChangeQuantity);
    })


}

function handleVariantChangeQuantity(event) {
  
  
  const variantId = event.target.getAttribute("data-variant-id");
  const productId = event.target.getAttribute("data-product-id");
  const price = event.target.getAttribute("data-variant-price");
  

  document.querySelectorAll('.cartx-product-button-wrap[data-product-id="' + productId + '"]').forEach(function (selector) {
    selector.setAttribute("data-variant-id", variantId);
    selector.setAttribute("data-price", price);
    
  });

  let quantity = 0;

  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == variantId);
    quantity = cartItem ? cartItem.quantity : 0;
  }

  updateQuantity({ [variantId]: { quantity } }, 'CHANGE');
}

function openDrawer(event) {
  event.preventDefault();
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.add("drawer-open");
    overlay.classList.add("open-overlay");
  }
  document.body.classList.add("cartx-open");
  
  // Add click handler to window
  setTimeout(() => {
    window.onclick = function(event) {
      const cartDrawer = document.querySelector("cart-drawer");
      
      if (cartDrawer && cartDrawer.classList.contains("drawer-open")) {
        // Check if clicked on overlay or cart-drawer but not on inner content
        if (event.target.id === "cartx-drawer-overlay" || 
            (event.target.tagName === "CART-DRAWER" && event.target === cartDrawer)) {
          closeDrawer();
        }
      }
    };
  }, 100);
}

function closeDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.remove("drawer-open");
    overlay.classList.remove("open-overlay");
  }

  document.body.classList.remove("cartx-open");
  window.onclick = null;
}

function cartx(variantObject = {}, event) {
  if (isProcessing) {
    updateQuantity(variantObject, null);
    return;
  }

  isProcessing = true;
  startLoader();

  const allProducts = {};

  const filteredObjects = JSON.parse(document.body.getAttribute("metaobject"));
  const cartFreebie = cleanData(
    JSON.parse(document.body.getAttribute("cartfreebie"))
  );

  

  let claimGift = JSON.parse(document.body.getAttribute("claimgift")) || [];
  let claimGiftLimit = claimGift[0]?.gift_limit || 1;

  

  let localStorageClaimGift = JSON.parse(
    localStorage.getItem("claimedGiftProducts")
  ) || {};

  

  const cartUpdatedObject = {};
  let totalFreeProduct = 0;
  let totalFreeProductPrice = 0;
  let totalCombosQuantity = 0;
  let totalCombosPrice = 0;

  let isClaimedGift = false;

  user_cart?.items.forEach(
    ({
      id,
      quantity,
      final_line_price,
      original_line_price,
      product_type,
      properties,
    }) => {
      const productId = id.toString();

      allProducts[productId] = Number(allProducts[productId] || 0) + quantity;

      if (!cartUpdatedObject[productId])
        cartUpdatedObject[productId] = quantity;

      if (
        (final_line_price === freeGiftPrice && original_line_price === freeGiftPrice) ||
        (final_line_price === 0 && original_line_price === 0)
      ) {
        totalFreeProduct++;
        totalFreeProductPrice += final_line_price;
        if (properties?.claimed_gift !== "true") {
          cartUpdatedObject[productId] = 0;
        }
      }

      if (product_type === "Combos") {
        totalCombosQuantity += quantity;
        totalCombosPrice += final_line_price;
      }
    }
  );

  const cartTotalProductWithoutFreebie =
    user_cart?.item_count - totalFreeProduct - totalCombosQuantity;
  const cartTotalPriceWithoutFreebie =
    user_cart?.total_price - totalFreeProductPrice - totalCombosPrice;

  let totalQuantity = 0;
  let totalPrice = 0;

  let claimedGiftProducts = {};

  

  Object.entries(variantObject).forEach(([key, variant]) => {
    if (variant?.replace_variant) {

      const replaceId = variant.replace_variant;

      // Find the quantity & price of the current cart item being replaced
      const matchedItems = user_cart?.items.filter(
        (item) => item.id.toString() === replaceId
      );


      const itemWithSpecificPrice = matchedItems?.find(
        (item) => Number(item.final_price) === Number(variant?.final_price)
      );


      if (itemWithSpecificPrice) {
        const oldQty = itemWithSpecificPrice.quantity;
        const oldPrice = itemWithSpecificPrice.final_line_price;

        // Reduce totals to offset the old variant being removed
        totalQuantity -= oldQty;
        totalPrice -= oldPrice;

        // Mark the old variant for removal
        cartUpdatedObject[replaceId] = 0;
      }

    }

    if (variant?.type !== "Combos" && variant?.claimed_gift !== "true") {
      totalQuantity += variant?.quantity;
      totalPrice += variant?.price * variant?.quantity;
    }

    if (variant?.claimed_gift === "true") {
      
      localStorageClaimGift[key] = event === "CLAIM_ADD" ? variant?.quantity : 0;
    }
  });

  
  

  if (Object.entries(localStorageClaimGift)?.length > 0) {
    const existingClaimGift = Object.values(localStorageClaimGift).filter(value => value > 0).length;
    if(existingClaimGift <= claimGiftLimit){
      localStorage.setItem(
        "claimedGiftProducts",
        JSON.stringify(localStorageClaimGift)
    );
    }
    else{
      showMessage("You can only claim up to " + claimGiftLimit + " gifts", true);
      isProcessing = false;
      stopLoader();
      return;
    }

  }

  const adjustedCartQuantity =
    cartTotalProductWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalQuantity
      : event === "REMOVE"
      ? -totalQuantity
      : 0);

  const adjustedCartPrice =
    cartTotalPriceWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE"
      ? -totalPrice
      : 0);

  const discountPriceCheck =
    user_cart?.total_price +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE"
      ? -totalPrice
      : 0);

  // Find applicable rule
  const applicableRule = getApplicableRule(
    filteredObjects,
    adjustedCartQuantity,
    adjustedCartPrice
  );

  if (applicableRule?.get_y?.length) {
    /* Track freebie debug info in cart attributes — shows up in order notes */
    var _freebieDebug = {
      cartQty: adjustedCartQuantity,
      cartPrice: adjustedCartPrice,
      trigger: applicableRule.trigger_price || applicableRule.triggered_quantity,
      freebies: applicableRule.get_y.map(v => v.split("/").pop()).join(","),
      ts: new Date().toISOString()
    };
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { _freebie_debug: JSON.stringify(_freebieDebug) } })
    }).catch(function() {});
    applicableRule.get_y.forEach((variant) => {
      var vid = variant.split("/").pop();
      if (!invalidFreebieVariants.has(vid)) {
        cartUpdatedObject[vid] = 1;
      }
    });
  }

  //Claim Gift Logic
  // Check if the gift is claimed
  
  
    const applicableRuleClaimGift = getApplicableRule(
      claimGift,
      adjustedCartQuantity,
      adjustedCartPrice
    );

    if (applicableRuleClaimGift) {
      if (applicableRuleClaimGift?.gift_products?.length) {
        if (localStorageClaimGift) {
          applicableRuleClaimGift.gift_products.forEach((variant) => {
            var variantId = variant.split("/").pop();
            if (localStorageClaimGift.hasOwnProperty(variantId)) {
              cartUpdatedObject[variantId] = localStorageClaimGift[variantId];
            }
          });
        }
      }
    } else {
      localStorage.removeItem("claimedGiftProducts");
    }
  

  // Update cart quantities based on event
  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const currentQty = cartUpdatedObject[productId] || 0;
    const currentQuantiyAll = allProducts[productId] || 0;
    cartUpdatedObject[productId] =
      event === "ADD"
        ? currentQty + quantity
        : event === "MULTI_ADD"
        ? 1
        : event === "REMOVE"
        ? Math.max(0, currentQty - quantity)
        : currentQty;

        allProducts[productId] =
        event === "ADD"
          ? currentQuantiyAll + quantity
          : event === "MULTI_ADD"
          ? 1
          : event === "REMOVE"
          ? Math.max(0, currentQty - quantity)
          : currentQty;
  });

  // Apply freebie rules
  cartFreebie?.forEach(({ freebie, products }) => {
    if (freebie?.length > 0) {
      products.forEach((productId) => {
        if (
          cartUpdatedObject[productId] &&
          cartUpdatedObject[productId] !== 0
        ) {
          var fid = freebie[0];
          if (!invalidFreebieVariants.has(fid)) {
            cartUpdatedObject[fid] = 1;
          }
        }
      });
    }
  });

  // If no real (non-free) products remain after adjustments, remove all freebies.
  // Count real products: any item with qty > 0 that is NOT a known freebie.
  const freebieIds = new Set();
  cartFreebie?.forEach(({ freebie }) => {
    if (freebie?.length) freebie.forEach((id) => freebieIds.add(id.toString()));
  });
  if (applicableRule?.get_y?.length) {
    applicableRule.get_y.forEach((v) => freebieIds.add(v.split("/").pop()));
  }
  // Also treat any item the initial loop zeroed out (free-price items) as freebie
  user_cart?.items.forEach(({ id, final_line_price, original_line_price }) => {
    if (
      (final_line_price === freeGiftPrice && original_line_price === freeGiftPrice) ||
      (final_line_price === 0 && original_line_price === 0)
    ) {
      freebieIds.add(id.toString());
    }
  });

  let realProductCount = 0;
  Object.entries(cartUpdatedObject).forEach(([key, qty]) => {
    if (qty > 0 && !freebieIds.has(key)) realProductCount += qty;
  });

  if (realProductCount <= 0) {
    Object.keys(cartUpdatedObject).forEach((key) => {
      cartUpdatedObject[key] = 0;
    });
    localStorage.removeItem("claimedGiftProducts");
  }

  if(checkExceedLimit(allProducts, 15)){
    showExceedingMessage("You can only add up to 15 of the same item");
    updateQuantity(variantObject, null);
    stopLoader();
    isProcessing = false;
    return;
  }

  



  const finalPayload = { updates: cartUpdatedObject };
  console.log("devx-cartx finalPayload:", JSON.stringify(finalPayload, null, 2));

  if (Object.keys(cartUpdatedObject).length > 0) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        cache: "no-store",
        priority: "high",
        keepalive: true,
      },
      body: JSON.stringify(finalPayload),
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((errBody) => {
            console.error("devx-cartx 422 response body:", errBody);
            /* If "Cannot find variant", remove freebie variants and retry with just real products */
            if (res.status === 422 && errBody?.description?.includes("Cannot find variant") && freebieIds.size > 0) {
              console.warn("devx-cartx: freebie variant not found, retrying without freebies");
              /* Mark freebie variants as invalid so future cartx() calls skip them */
              freebieIds.forEach(function(id) { invalidFreebieVariants.add(id); });
              var retryPayload = {};
              Object.entries(cartUpdatedObject).forEach(function([key, qty]) {
                if (!freebieIds.has(key)) retryPayload[key] = qty;
              });
              if (Object.keys(retryPayload).length > 0) {
                return fetch("/cart/update.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  body: JSON.stringify({ updates: retryPayload })
                }).then(function(r) { return r.json(); });
              }
            }
            throw new Error(`devx-cartx HTTP error! status: ${res.status}`);
          });
        }
        return res.json();
      })
      .then((data) => {
        user_cart = data;
        isProcessing = false;
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: data }
        }));

        // If only free/zero-price items remain (bundle add-ons were removed by app),
        // clean up freebies so cart shows empty instead of orphaned freebies.
        const freshRealItems = (data.items || []).filter(function (item) {
          return item.final_line_price > 0 || item.original_line_price > 0;
        });
        if (freshRealItems.length === 0 && data.items?.length > 0) {
          const cleanupUpdates = {};
          data.items.forEach(function (item) { cleanupUpdates[item.id] = 0; });
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: cleanupUpdates })
          })
          .then(function (res) { return res.json(); })
          .then(function (cleanCart) {
            user_cart = cleanCart;
            localStorage.removeItem("claimedGiftProducts");
            reload_cartx();
            updateBubble(0);
          })
          .catch(function (err) {
            console.error("devx-cartx freebie cleanup failed:", err);
          });
          return;
        }

        if (
          data?.total_price !== discountPriceCheck &&
          data?.total_price !== 0
        ) {
          cartx();
          updateQuantity(variantObject, event);
        } else {
          reload_cartx(); // Now safely called after update completes
          updateQuantity(variantObject, event);
          updateBubble(user_cart?.item_count);
          // currentDiscountCodes =  user_cart?.attributes?.appliedDiscount.split(',') || [];
          checkDiscountCode(user_cart);
        }
        if (event === "ADD" || event === "MULTI_ADD") {
          document.querySelector('.cartx-add-to-cart-popup')?.classList.remove('hide');
          hideCartOpenTost();
        }
      })
      .catch((error) => {
        console.error("devx-cartx Error updating cart:", error);
        reload_cartx();
        stopLoader();
        isProcessing = false;
      })
      .finally(() => {});
  } else {
    bindingEvent();
    stopLoader();
    checkDiscountCode(user_cart);
    isProcessing = false;
    // currentDiscountCodes =  user_cart?.attributes?.appliedDiscount.split(',') || [];
  }
}

function checkExceedLimit(object, limit) {
  return Object.values(object).some(value => value > limit);
}

function hideCartOpenTost() {
  setTimeout(function () {
    document.querySelectorAll('.cartx-add-to-cart-popup').forEach(function(el) {
      el.classList.add('hide');
    });
  }, 5000);
}

// Function to clean the cartFreebie data
function cleanData(cartFreebie) {
  if (!Array.isArray(cartFreebie)) return [];
  return cartFreebie
    .filter((item) => Array.isArray(item.freebie) && Array.isArray(item.products))
    .map((item) => ({
      freebie: item.freebie.map((id) =>
        id.replace("gid://shopify/ProductVariant/", "")
      ),
      products: item.products.map((id) =>
        id.replace("gid://shopify/ProductVariant/", "")
      ),
    }));
}

function getApplicableRule(
  filteredObjects,
  adjustedCartQuantity,
  adjustedCartPrice
) {
  if (!filteredObjects || !filteredObjects.length) return null;

  const applicableRules = filteredObjects.filter(
    ({ triggered_quantity, trigger_price }) => {
      if (triggered_quantity !== undefined && Number(triggered_quantity) > 0) {
        return adjustedCartQuantity >= triggered_quantity;
      } else if (trigger_price !== undefined && Number(trigger_price) > 0) {
        return adjustedCartPrice >= trigger_price * 100;
      }
      return false;
    }
  );

  const sortedRules = applicableRules.sort((a, b) => {
    const aVal =
      a.triggered_quantity !== undefined
        ? a.triggered_quantity
        : a.trigger_price !== undefined
        ? a.trigger_price * 100
        : 0;

    const bVal =
      b.triggered_quantity !== undefined
        ? b.triggered_quantity
        : b.trigger_price !== undefined
        ? b.trigger_price * 100
        : 0;

    return bVal - aVal; // descending
  });

  return sortedRules[0] || null;
}

function reload_cartx(cart_visible = false, event = null) {
  const sectionId = "cartx-drawer";

  const currentInner = document.querySelector(
    `#shopify-section-${sectionId} .cartx-drawer-inner`
  );

  const oldBottomCart = document.querySelector(
    `#shopify-section-${sectionId} #cartx-bottom-cart`
  );
  currentInner?.classList.add("is-loading");
  let cartScrollPosition = document.querySelector('.cartx-drawer-body-wrap').scrollTop;

  fetch(window.location.pathname + `?sections=${sectionId}`, {
    cache: "no-store",
    priority: "high",
    keepalive: true,
  })
    .then((res) => res.json())
    .then((data) => {
      const updated_cart_html = data[sectionId];

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(updated_cart_html, "text/html");
      const newCartInner = htmlDoc.querySelector(".cartx-drawer-inner");
      const bottomCart = htmlDoc.getElementById("cartx-bottom-cart");

      // Toggle empty cart class on cart-drawer element
      const cartDrawerEl = document.querySelector("cart-drawer");
      const newCartDrawerEl = htmlDoc.querySelector("cart-drawer");
      if (cartDrawerEl && newCartDrawerEl) {
        if (newCartDrawerEl.classList.contains("cartx-is-empty")) {
          cartDrawerEl.classList.add("cartx-is-empty");
        } else {
          cartDrawerEl.classList.remove("cartx-is-empty");
        }
      }

      if (newCartInner && currentInner) {
        currentInner.innerHTML = newCartInner.innerHTML;
        var bodyWrap = document.querySelector('.cartx-drawer-body-wrap');
        if (bodyWrap) bodyWrap.scrollTop = cartScrollPosition;
        if(showConfetti){
          cartConfetti();
        }
        showConfetti = false;

        const ai_base_upsell = newCartInner.getAttribute("ai-cart-upsell"); 
        console.log("AI Base Upsell:", ai_base_upsell);
        if (ai_base_upsell && ai_base_upsell == "true") {
          if (user_cart?.item_count > 0) {
            updateAiUpsell(user_cart?.items);
          }
          bindingEvent();
        }else{
          bindingEvent();
          loadedEvents();
        }
        filterCouponsByUtm();
        applyUtmSectionOverrides();
        
      }
      if (oldBottomCart && bottomCart) {
        oldBottomCart.innerHTML = bottomCart.innerHTML;
        if (user_cart?.item_count > 0) {
          oldBottomCart.classList.add("show-slide");
        } else {
          oldBottomCart.classList.remove("show-slide");
        }
      }
    })
    .catch((error) => {
      console.error("Error reloading cart:", error);
    })
    .finally(() => {
      currentInner?.classList.remove("is-loading");
      stopLoader();
      loadedEvents();
    });
}

function updateQuantity(variantObject = {}, event) {
  if (!variantObject) return;

  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const quantityElementsWrapper = document.querySelectorAll(
      '.cartx-product-button-wrap[data-variant-id="' + productId + '"]'
    );

    quantityElementsWrapper?.forEach((element) => {
      // Pattern A: cartx-add-to-cart-button.liquid (uses <input class="cartx-atc-qty">)
      const el = element.querySelector(".cartx-atc-qty");
      // Pattern B: product-item.liquid (uses <button class="atc_with_qty"> with innerText for qty)
      const qtyBtn = element.querySelector(".atc_with_qty");
      // loader-button wraps content in .loader-button__text span — read/write that to avoid NaN
      const qtyBtnText = qtyBtn ? (qtyBtn.querySelector(".loader-button__text") || qtyBtn) : null;

      if (el || qtyBtn) {
        const addToCart = element.querySelector(".cartx-add-to-cart:not(.plus):not(.custom_plus)");
        const plusMinusWrapper = element.querySelector(".cartx-add-to-cart-qty-wrap") || element.querySelector(".ctm_atc_btn");

        var currentVal = el ? Number(el.value) : Number(qtyBtnText?.textContent || 0);
        var newVal = currentVal;

        if (event) {
          if (event === 'CHANGE') {
            newVal = Number(quantity);
          } else {
            newVal = currentVal + ((event === "ADD" || event === "MULTI_ADD" ? 1 : -1) * Number(quantity));
          }
        }

        if (el) el.value = newVal;
        if (qtyBtnText) qtyBtnText.textContent = newVal;

        if (newVal > 0) {
          if (addToCart) { addToCart.classList.add("hide"); addToCart.style.removeProperty("display"); }
          if (plusMinusWrapper) { plusMinusWrapper.classList.remove("hide"); plusMinusWrapper.style.removeProperty("display"); }
        } else {
          if (addToCart) { addToCart.classList.remove("hide"); addToCart.style.removeProperty("display"); }
          if (plusMinusWrapper) { plusMinusWrapper.classList.add("hide"); plusMinusWrapper.style.removeProperty("display"); }
        }
      }

      if (element.classList.contains("cartx-button-loadding")) {
        element.classList.remove("cartx-button-loadding");
      }
      var busyBtn = element.querySelector('[aria-busy="true"]');
      if (busyBtn) busyBtn.removeAttribute("aria-busy");
    });
  });
}


function updateBubble(cartCount) {
  const bubbleElements = document.querySelectorAll(".cart-count-bubble");

  const bubbleEle = document.getElementById("cart-icon-bubble");

  bubbleElements.forEach((bubble) => {
    bubbleCount(bubble, cartCount);
  });

  bubbleCount(bubbleEle, cartCount);

  // Update <cart-count> custom elements in the header
  document.querySelectorAll("cart-count").forEach((el) => {
    el.innerText = cartCount;
  });

  // Update cart drawer item count badges
  document.querySelectorAll(".cartx-drawer-item-count").forEach((el) => {
    el.textContent = cartCount + " items";
    el.setAttribute("data-count", cartCount);
  });

  // When cart is empty, reset all product page quantity buttons (exclude drawer buttons)
  if (cartCount === 0) {
    document.querySelectorAll(".cartx-product-button-wrap").forEach((wrap) => {
      if (wrap.closest(".cartx-drawer")) return;
      // Pattern A: cartx-add-to-cart-button.liquid
      var qtyInput = wrap.querySelector(".cartx-atc-qty");
      // Pattern B: product-item.liquid (loader-button wraps text in .loader-button__text)
      var qtyBtn = wrap.querySelector(".atc_with_qty");
      var qtyBtnText = qtyBtn ? (qtyBtn.querySelector(".loader-button__text") || qtyBtn) : null;
      var addBtn = wrap.querySelector(".cartx-add-to-cart:not(.plus):not(.custom_plus)");
      var plusMinusWrap = wrap.querySelector(".cartx-add-to-cart-qty-wrap") || wrap.querySelector(".ctm_atc_btn");

      if (qtyInput) qtyInput.value = 0;
      if (qtyBtnText) qtyBtnText.textContent = 0;
      if (addBtn) { addBtn.classList.remove("hide"); addBtn.style.removeProperty("display"); }
      if (plusMinusWrap) { plusMinusWrap.classList.add("hide"); plusMinusWrap.style.removeProperty("display"); }
    });
  }
}

function bubbleCount(bubble, cartCount) {
  if (!bubble) return;
  const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
  const hiddenCount = bubble.querySelector(".visually-hidden");

  if (visibleCount) visibleCount.textContent = cartCount;
  if (hiddenCount) hiddenCount.textContent = `${cartCount} items`;
}

function applyCode(codeInput = null) {
  const code = (
    codeInput || document.querySelector(".prv-coupon-input")
  ).value.trim();

  applyDiscount(user_cart?.token, code);
}

// Validate discount code format
function validateDiscountCode(code) {
  // Basic validation - adjust pattern as needed
  return code.replace(/[^\w\-]/g, "");
}

async function applyDiscount(cartId, discountCode) {
  if (!discountCode) {
    showMessage("Please enter a discount code.", true);
    return;
  }

  if (typeof user_cart === "undefined" || user_cart?.item_count === 0) {
    showMessage("Your cart is empty. Add items before applying a code.", true);
    return;
  }

  const sanitizedCode = validateDiscountCode(discountCode);
  if (!sanitizedCode) {
    showMessage("Invalid discount code format.", true);
    return;
  }

  const upperCaseCode = sanitizedCode.toUpperCase();

  if (currentDiscountCodes.includes(upperCaseCode)) {
    showMessage(`Discount code "${sanitizedCode}" is already applied.`, true);
    return;
  }
  startLoader();
  const updatedDiscountCodes = [...currentDiscountCodes, upperCaseCode];

  const query = `
    mutation {
      cartDiscountCodesUpdate(cartId: "gid://shopify/Cart/${cartId}", discountCodes: ${JSON.stringify(
    updatedDiscountCodes
  )}) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(shopifyStorefrontApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": shopifyStorefrontToken,
      },
      body: JSON.stringify({ query }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      stopLoader();
      throw new Error(`API responded with status ${response.status}`);
    }

    const data = await response.json();

    if (data.errors) {
      const firstError = data.errors[0];
      const message =
        firstError.extensions?.code === "UNAUTHORIZED"
          ? "Session expired. Please refresh the page and try again."
          : `Error: ${firstError.message}`;
      showMessage(message, true);
      stopLoader();

      return;
    }

    const discountInfo = data.data?.cartDiscountCodesUpdate;

    if (discountInfo?.userErrors?.length) {
      showMessage(discountInfo.userErrors[0].message, true);
      stopLoader();
    } else {
      const allDiscounts = discountInfo.cart.discountCodes;
      const applicableDiscounts = allDiscounts.filter((d) => d.applicable);
      const newCodeStatus = allDiscounts.find(
        (d) => d.code.toUpperCase() === sanitizedCode.toUpperCase()
      );

      if (newCodeStatus?.applicable) {
        fetchCart();
        showConfetti = true;
      } else {
        showMessage(
          `Discount code "${sanitizedCode}" is not applicable to your cart.`,
          true
        );
        stopLoader();
      }
    }
  } catch (error) {
    stopLoader();
    console.error("Error applying discount:", error);
    const message =
      error.name === "AbortError"
        ? "Request timed out. Please try again."
        : error.message.includes("NetworkError")
        ? "Network error. Please check your connection and try again."
        : "Error applying discount. Please try again later.";
    showMessage(message, true);
  }
}

async function removeDiscount(cartId, discountCode) {
  startLoader();

  let removeDiscount = [
    ...currentDiscountCodes?.filter(
      (item) => item.toUpperCase() !== discountCode.toUpperCase()
    ),
  ];

  const query = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    cartId: `gid://shopify/Cart/${cartId}`,
    discountCodes: removeDiscount,
  };

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(shopifyStorefrontApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": shopifyStorefrontToken,
      },
      body: JSON.stringify({ query, variables }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      stopLoader();
      throw new Error(`API responded with status ${response.status}`);
    }

    const data = await response.json();

    if (data.errors) {
      const firstError = data.errors[0];
      const message =
        firstError.extensions?.code === "UNAUTHORIZED"
          ? "Session expired. Please refresh the page and try again."
          : `Error: ${firstError.message}`;
      showMessage(message, true);
      stopLoader();

      return;
    }

    const discountInfo = data.data?.cartDiscountCodesUpdate;

    if (discountInfo?.userErrors?.length) {
      showMessage(discountInfo.userErrors[0].message, true);
      stopLoader();
    } else {
      const allDiscounts = discountInfo.cart.discountCodes;
      const applicableDiscounts = allDiscounts.filter((d) => d.applicable);

      currentDiscountCodes = applicableDiscounts.map((d) =>
        d.code.toUpperCase()
      );

      cartx();
    }
  } catch (error) {
    stopLoader();
    console.error("Error applying discount:", error);
    const message =
      error.name === "AbortError"
        ? "Request timed out. Please try again."
        : error.message.includes("NetworkError")
        ? "Network error. Please check your connection and try again."
        : "Error applying discount. Please try again later.";
    showMessage(message, true);
  }
}

function checkDiscountCode(cart) {
  const uniqueDiscountCodes = new Set();
  cart?.items.forEach((item) => {
    item.line_level_discount_allocations
      .filter((item) => item.discount_application.type === "discount_code")
      .forEach((item) =>
        uniqueDiscountCodes.add(item.discount_application.title)
      );
  });
  cart.cart_level_discount_applications
    .filter((item) => item.discount_application?.type === "discount_code")
    .forEach((item) =>
      uniqueDiscountCodes.add(item.discount_application.title)
    );

  currentDiscountCodes = [...uniqueDiscountCodes].map((code) =>
    code.toUpperCase()
  );
  
}

function showMessage(message, isError = false) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add(isError ? "red-message" : "green-message");
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove(isError ? "red-message" : "green-message");
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 3000);
}

function showExceedingMessage(message) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add('purple-message');
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove('purple-message');
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 2000);
}


function updateAiUpsell(variants) {
  var upsellWrap = document.querySelector(".cartx-ai-upsell");
  var mobileRecsWrap = document.querySelector(".cartx-filled-mobile-recs");
  var mobileRecsContainer = document.getElementById("cartx-mobile-upsell-list");
  var container = document.getElementById("cartx-upsell-product-list");

  /* Collect cart product IDs to filter out already-in-cart items */
  var cartProductIds = variants ? variants.map(function(v) { return v.product_id; }) : [];
  var firstProductId = cartProductIds[0];

  if (!firstProductId) {
    if (upsellWrap) upsellWrap.style.display = "none";
    if (mobileRecsWrap) mobileRecsWrap.style.display = "none";
    loadedEvents();
    return;
  }

  /* Try Shopify native recommendations first, fallback to AI API */
  fetchShopifyRecommendations(firstProductId, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds, variants);
}

/* ===== Shopify native product recommendations (same as mini-cart) ===== */
/* Try complementary (frequently bought together) first, then related, then AI API */
function fetchShopifyRecommendations(productId, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds, variants) {
  fetch("/recommendations/products.json?product_id=" + productId + "&limit=10&intent=complementary")
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = (data && data.products) ? data.products : [];
      products = products.filter(function(p) { return cartProductIds.indexOf(p.id) === -1; });

      if (products.length > 0) {
        renderShopifyRecsProducts(products, container, upsellWrap, mobileRecsWrap, mobileRecsContainer);
      } else {
        fetchShopifyRelated(productId, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds, variants);
      }
    })
    .catch(function() {
      fetchShopifyRelated(productId, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds, variants);
    });
}

/* ===== Shopify related recommendations fallback ===== */
function fetchShopifyRelated(productId, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds, variants) {
  fetch("/recommendations/products.json?product_id=" + productId + "&limit=10&intent=related")
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = (data && data.products) ? data.products : [];
      products = products.filter(function(p) { return cartProductIds.indexOf(p.id) === -1; });

      if (products.length > 0) {
        renderShopifyRecsProducts(products, container, upsellWrap, mobileRecsWrap, mobileRecsContainer);
      } else {
        fetchAiUpsell(variants, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds);
      }
    })
    .catch(function() {
      fetchAiUpsell(variants, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds);
    });
}

/* ===== AI API fallback ===== */
function fetchAiUpsell(variants, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer djDPgUJxjR13M1ph61ufS789V0WSgKIz3E74Lcbu");

  var productGIDs = encodeURIComponent(
    JSON.stringify(variants.map(function(p) { return "gid://shopify/Product/" + p.product_id; }))
  );

  fetch(
    "https://gn30lesfub.execute-api.ap-south-1.amazonaws.com/prod/a4e14a0f-d276-4781-8e3d-2f91243335b8/datasource/2465f2a6-6498-40bd-9008-e6c7a6b017eb/upsell?ids=" + productGIDs,
    { method: "GET", headers: myHeaders, redirect: "follow" }
  )
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data && data.products && data.products.length > 0 && Array.isArray(data.products)) {
        renderAiUpsellProducts(data.products, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds);
      } else {
        if (upsellWrap) upsellWrap.style.display = "none";
        if (mobileRecsWrap) mobileRecsWrap.style.display = "none";
        loadedEvents();
      }
    })
    .catch(function() {
      if (upsellWrap) upsellWrap.style.display = "none";
      if (mobileRecsWrap) mobileRecsWrap.style.display = "none";
      loadedEvents();
    });
}

/* ===== Render Shopify native recommendation products ===== */
function renderShopifyRecsProducts(products, container, upsellWrap, mobileRecsWrap, mobileRecsContainer) {
  if (mobileRecsWrap) mobileRecsWrap.style.display = "flex";

  var shownCount = 0;
  products.forEach(function(product) {
    if (shownCount >= 6) return;

    /* Skip out-of-stock products */
    if (!product.available) return;

    var variant = product.variants[0];
    if (!variant || !variant.available) return;

    shownCount++;
    if (upsellWrap) upsellWrap.style.display = "block";

    var image = product.featured_image || (product.images && product.images[0]) || "";
    var title = product.title || "Untitled";
    var productType = product.product_type || "";
    var productUrl = product.url || ("/products/" + product.handle);
    var price = variant.price ? (variant.price / 100) : 0;
    var compareAtPrice = variant.compare_at_price ? (variant.compare_at_price / 100) : 0;

    /* Desktop sidebar card */
    if (container) {
      var upsellDiv = document.createElement("div");
      upsellDiv.className = "cartx-upsell-product-item";
      upsellDiv.setAttribute("data_prod_id", variant.id);

      var variantOptionsHTML = "";
      if (product.variants.length > 1) {
        variantOptionsHTML = '<div class="cartx-variant-selector-wrapper"><select class="cartx-variant-dropdown-main cartx-variant-upsell">' +
          product.variants.map(function(v) {
            return '<option data-quantity="1" data-image="' + (v.featured_image ? v.featured_image.src : image) + '" data-price="' + v.price + '" data-product-type="' + productType + '" value="' + v.id + '"' + (v.id === variant.id ? ' selected' : '') + '>' + v.title + '</option>';
          }).join('') + '</select></div>';
      }

      upsellDiv.innerHTML =
        '<div class="cartx-upsell-item-media"><img class="cartx-upsell-item-img" width="74" height="74" src="' + image + '" alt="' + title + '"></div>' +
        '<div class="cartx-upsell-item-info">' +
          '<a href="' + productUrl + '" class="cartx-upsell-item-title">' + title + '</a>' +
          '<div class="cartx-upsell-item-price-wrap"><div class="cartx-upsell-item-price"><span class="current-price">₹ ' + price + '</span></div>' + variantOptionsHTML + '</div>' +
          '<div class="cartx-product-button-wrap" data-variant-id="' + variant.id + '" data-quantity="1" data-price="' + variant.price + '" data-product-type="' + productType + '">' +
            '<div class="cartx-add-to-cart"><span>Add to Cart</span></div>' +
            '<div class="cartx-atc-loading" style="display:none;"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path></svg></div>' +
          '</div>' +
        '</div>';

      container.appendChild(upsellDiv);
    }

    /* Mobile card */
    if (mobileRecsContainer && shownCount <= 5) {
      var mobileCard = document.createElement("div");
      mobileCard.className = "cartx-mobile-recs-card";
      mobileCard.setAttribute("data_prod_id", variant.id);

      var mDiscountHtml = "";
      if (compareAtPrice && compareAtPrice > price) {
        var mDiscPct = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
        mDiscountHtml = '<span class="cartx-mobile-recs-compare">₹' + compareAtPrice + '</span><span class="cartx-mobile-recs-current">₹' + price + '</span><span class="cartx-mobile-recs-discount">' + mDiscPct + '%</span>';
      } else {
        mDiscountHtml = '<span class="cartx-mobile-recs-current">₹' + price + '</span>';
      }

      mobileCard.innerHTML =
        '<div class="cartx-mobile-recs-img-wrap">' +
          '<img class="cartx-mobile-recs-img" width="84" height="84" src="' + image + '" alt="' + title + '">' +
          '<div class="cartx-mobile-recs-atc-wrap cartx-product-button-wrap" data-product-id="' + product.id + '" data-variant-id="' + variant.id + '" data-quantity="1" data-price="' + variant.price + '" data-product-type="' + productType + '">' +
            '<button type="button" class="cartx-add-to-cart cartx-mobile-recs-atc-btn"><span class="cartx-mobile-recs-plus">+</span></button>' +
            '<div class="cartx-atc-loading" style="display:none;"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path></svg></div>' +
          '</div>' +
        '</div>' +
        '<div class="cartx-mobile-recs-info">' +
          '<a class="cartx-mobile-recs-item-title" href="' + productUrl + '">' + title + '</a>' +
          '<div class="cartx-mobile-recs-price-row">' + mDiscountHtml + '</div>' +
        '</div>';

      mobileRecsContainer.appendChild(mobileCard);
    }
  });

  loadedEvents();
}

/* ===== Render AI API upsell products ===== */
function renderAiUpsellProducts(products, container, upsellWrap, mobileRecsWrap, mobileRecsContainer, cartProductIds) {
  if (mobileRecsWrap) mobileRecsWrap.style.display = "flex";

  products.forEach(function(product, index) {
    if (upsellWrap) upsellWrap.style.display = "block";

    var variant = product?.variants?.edges?.[0]?.node;
    if (!variant) return;

    var image = variant?.image?.url || "";
    var title = product?.title || "Untitled";
    var productType = product?.productType || "";
    var productUrl = "/products/" + (product?.handle || "");

    var aiVariants = product?.variants?.edges || [];
    var selectedVariantId = product?.selectedVariant?.id?.replace("gid://shopify/ProductVariant/", "");
    var variantOptionsHTML = "";

    if (aiVariants.length > 1) {
      variantOptionsHTML = '<div class="cartx-variant-selector-wrapper"><select class="cartx-variant-dropdown-main cartx-variant-upsell">' +
        aiVariants.map(function(e) {
          var n = e.node;
          var vId = n.id.replace("gid://shopify/ProductVariant/", "");
          var vPrice = (n.price.amount) * 100;
          var vImg = n.image?.url || "";
          return '<option data-quantity="1" data-image="' + vImg + '" data-price="' + vPrice + '" data-product-type="' + productType + '" value="' + vId + '"' + (vId === selectedVariantId ? ' selected' : '') + '>' + n.title + '</option>';
        }).join('') + '</select></div>';
    }

    var price = variant.price.amount ? variant.price.amount / 1 : "0";
    var compareAtPrice = variant.compareAtPrice?.amount ? variant.compareAtPrice.amount / 1 : "";

    /* Desktop sidebar card */
    if (container) {
      var upsellDiv = document.createElement("div");
      upsellDiv.className = "cartx-upsell-product-item";
      upsellDiv.setAttribute("data_prod_id", variant.id.replace("gid://shopify/ProductVariant/", ""));

      upsellDiv.innerHTML =
        '<div class="cartx-upsell-item-media"><img class="cartx-upsell-item-img" width="74" height="74" src="' + image + '&width=174" alt="' + title + '"></div>' +
        '<div class="cartx-upsell-item-info">' +
          '<a href="' + productUrl + '" class="cartx-upsell-item-title">' + title + '</a>' +
          '<div class="cartx-upsell-item-price-wrap"><div class="cartx-upsell-item-price"><span class="current-price">₹ ' + price + '.00</span></div>' + variantOptionsHTML + '</div>' +
          (!priceArray.includes(price) ? (
            '<div class="cartx-product-button-wrap" data-variant-id="' + variant.id.replace("gid://shopify/ProductVariant/", "") + '" data-quantity="1" data-price="' + (variant.price.amount * 100) + '" data-product-type="' + productType + '">' +
              '<div class="cartx-add-to-cart"><span>Add to Cart</span></div>' +
              '<div class="cartx-atc-loading" style="display:none;"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path></svg></div>' +
            '</div>'
          ) : '') +
        '</div>';

      container.appendChild(upsellDiv);
    }

    /* Mobile card */
    if (mobileRecsContainer && index < 5) {
      var mobileCard = document.createElement("div");
      mobileCard.className = "cartx-mobile-recs-card";
      mobileCard.setAttribute("data_prod_id", variant.id.replace("gid://shopify/ProductVariant/", ""));

      var mPrice = variant.price.amount ? variant.price.amount / 1 : "0";
      var mCompare = variant.compareAtPrice?.amount ? variant.compareAtPrice.amount / 1 : "";
      var mDiscountHtml = "";
      if (mCompare && mCompare > mPrice) {
        var mDiscPct = Math.round(((mCompare - mPrice) / mCompare) * 100);
        mDiscountHtml = '<span class="cartx-mobile-recs-compare">₹' + mCompare + '</span><span class="cartx-mobile-recs-current">₹' + mPrice + '</span><span class="cartx-mobile-recs-discount">' + mDiscPct + '%</span>';
      } else {
        mDiscountHtml = '<span class="cartx-mobile-recs-current">₹' + mPrice + '</span>';
      }

      mobileCard.innerHTML =
        '<div class="cartx-mobile-recs-img-wrap">' +
          '<img class="cartx-mobile-recs-img" width="84" height="84" src="' + image + '&width=300" alt="' + title + '">' +
          '<div class="cartx-mobile-recs-atc-wrap cartx-product-button-wrap" data-product-id="' + (product.id ? product.id.replace("gid://shopify/Product/", "") : "") + '" data-variant-id="' + variant.id.replace("gid://shopify/ProductVariant/", "") + '" data-quantity="1" data-price="' + (variant.price.amount * 100) + '" data-product-type="' + productType + '">' +
            '<button type="button" class="cartx-add-to-cart cartx-mobile-recs-atc-btn"><span class="cartx-mobile-recs-plus">+</span></button>' +
            '<div class="cartx-atc-loading" style="display:none;"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path></svg></div>' +
          '</div>' +
        '</div>' +
        '<div class="cartx-mobile-recs-info">' +
          '<a class="cartx-mobile-recs-item-title" href="' + productUrl + '">' + title + '</a>' +
          '<div class="cartx-mobile-recs-price-row">' + mDiscountHtml + '</div>' +
        '</div>';

      mobileRecsContainer.appendChild(mobileCard);
    }
  });

  loadedEvents();
}

// function triggerUpsellEvent() {
//   document.querySelectorAll(".cartx-upsell-add-to-cart").forEach((button) => {
//     button.addEventListener("click", (event) => {
//       event.preventDefault();
//       const variantId = button.getAttribute("data-variant-id");
//       if (!variantId) return;

//       const variantObject = {
//         [variantId]: {
//           quantity: parseInt(button.getAttribute("data-quantity")) || 0,
//           price: parseInt(button.getAttribute("data-price")) || 0,
//           type: button.getAttribute("data-product-type") || "",
//         },
//       };

//       cartx(variantObject, "ADD");
//     });
//   });
// }

/* ===== Ensure freebies are in cart before Gokwik checkout/buy-now ===== */
(function() {
  function ensureFreebiesInCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartFreebie = [];
        try {
          cartFreebie = cleanData(JSON.parse(document.body.getAttribute("cartfreebie"))) || [];
        } catch(e) {}

        var filteredObjects = [];
        try {
          filteredObjects = JSON.parse(document.body.getAttribute("metaobject")) || [];
        } catch(e) {}

        var cartItemIds = {};
        var cartQty = 0;
        var cartPrice = 0;
        cart.items.forEach(function(item) {
          cartItemIds[String(item.variant_id)] = item.quantity;
          /* Skip freebies from qty/price calculation */
          if (item.final_price > 0) {
            cartQty += item.quantity;
            cartPrice += item.final_line_price;
          }
        });

        var freebieUpdates = {};


        /* 1. Product-specific freebies (cartFreebie) */
        if (cartFreebie && cartFreebie.length) {
          cartFreebie.forEach(function(rule) {
            if (rule.freebie && rule.freebie.length && rule.products && rule.products.length) {
              rule.products.forEach(function(productId) {
                if (cartItemIds[productId] && cartItemIds[productId] > 0) {
                  var freebieId = rule.freebie[0];
                  if (!cartItemIds[freebieId]) {
                    freebieUpdates[freebieId] = 1;
                  }
                }
              });
            }
          });
        }

        /* 2. Tier-based freebies (metaobject — get_y) */
        if (filteredObjects && filteredObjects.length) {
          var applicableRule = getApplicableRule(filteredObjects, cartQty, cartPrice);
          if (applicableRule && applicableRule.get_y && applicableRule.get_y.length) {
            applicableRule.get_y.forEach(function(variant) {
              var vid = variant.split("/").pop();
              if (!cartItemIds[vid]) {
                freebieUpdates[vid] = 1;
              }
            });
          }
        }


        if (Object.keys(freebieUpdates).length > 0) {
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ updates: freebieUpdates })
          });
        } else {
        }
      });
  }

  /* Determine which freebie items should be in a given cart (without touching cart).
     Returns an array of {id, quantity, ...} objects for missing freebies. */
  function getFreebieItemsForCart(cart) {
    var freebieItems = [];
    var cartFreebie = [];
    try { cartFreebie = cleanData(JSON.parse(document.body.getAttribute("cartfreebie"))) || []; } catch(e) {}
    var filteredObjects = [];
    try { filteredObjects = JSON.parse(document.body.getAttribute("metaobject")) || []; } catch(e) {}

    var cartItemIds = {};
    var cartQty = 0;
    var cartPrice = 0;
    (cart.items || []).forEach(function(item) {
      cartItemIds[String(item.variant_id || item.id)] = item.quantity;
      if (item.final_price > 0) {
        cartQty += item.quantity;
        cartPrice += item.final_line_price;
      }
    });

    /* 1. Product-specific freebies */
    if (cartFreebie && cartFreebie.length) {
      cartFreebie.forEach(function(rule) {
        if (rule.freebie && rule.freebie.length && rule.products && rule.products.length) {
          rule.products.forEach(function(productId) {
            if (cartItemIds[productId] && cartItemIds[productId] > 0) {
              var fid = rule.freebie[0];
              if (!cartItemIds[fid]) {
                freebieItems.push({ id: parseInt(fid), variant_id: parseInt(fid), quantity: 1, price: 0, final_price: 0, original_price: 0, line_price: 0, final_line_price: 0, original_line_price: 0, title: "Freebie", properties: {} });
              }
            }
          });
        }
      });
    }

    /* 2. Tier-based freebies (metaobject get_y) */
    if (filteredObjects && filteredObjects.length) {
      var applicableRule = getApplicableRule(filteredObjects, cartQty, cartPrice);
      if (applicableRule && applicableRule.get_y && applicableRule.get_y.length) {
        applicableRule.get_y.forEach(function(variant) {
          var vid = variant.split("/").pop();
          if (!cartItemIds[vid]) {
            freebieItems.push({ id: parseInt(vid), variant_id: parseInt(vid), quantity: 1, price: 0, final_price: 0, original_price: 0, line_price: 0, final_line_price: 0, original_line_price: 0, title: "Freebie", properties: {} });
          }
        });
      }
    }

    return freebieItems;
  }

  /* Build freebie items for a given product variant (without touching cart) */
  function getFreebieItemsForProduct(variantId, quantity) {
    var freebieItems = [];
    var cartFreebie = [];
    try { cartFreebie = cleanData(JSON.parse(document.body.getAttribute("cartfreebie"))) || []; } catch(e) {}
    var filteredObjects = [];
    try { filteredObjects = JSON.parse(document.body.getAttribute("metaobject")) || []; } catch(e) {}

    /* 1. Product-specific freebies */
    if (cartFreebie && cartFreebie.length) {
      cartFreebie.forEach(function(rule) {
        if (rule.freebie && rule.freebie.length && rule.products && rule.products.length) {
          rule.products.forEach(function(productId) {
            if (String(productId) === String(variantId)) {
              freebieItems.push({ id: parseInt(rule.freebie[0]), quantity: 1, properties: {} });
            }
          });
        }
      });
    }

    /* 2. Tier-based freebies (get_y) */
    if (filteredObjects && filteredObjects.length) {
      /* Read variant price from the form or page */
      var priceEl = document.querySelector('.cartx-product-button-wrap[data-variant-id="' + variantId + '"]');
      var variantPrice = priceEl ? parseInt(priceEl.getAttribute("data-price")) || 0 : 0;
      /* Fallback: read from product JSON on PDP */
      if (!variantPrice) {
        try {
          var productJson = document.querySelector('[type="application/json"][data-product-json], [type="application/json"].product-json, script#product-json');
          if (productJson) {
            var pData = JSON.parse(productJson.textContent);
            var v = pData.variants ? pData.variants.find(function(vr) { return String(vr.id) === String(variantId); }) : null;
            if (v) variantPrice = v.price;
          }
        } catch(e) {}
      }
      var applicableRule = getApplicableRule(filteredObjects, quantity, variantPrice);
      if (applicableRule && applicableRule.get_y && applicableRule.get_y.length) {
        applicableRule.get_y.forEach(function(variant) {
          var vid = parseInt(variant.split("/").pop());
          freebieItems.push({ id: vid, quantity: 1, properties: {} });
        });
      }
    }

    return freebieItems;
  }

  /* Intercept Gokwik onBuyNowClick — add freebies to items list */
  var _checkBuyNow = setInterval(function() {
    if (typeof window.onBuyNowClick === "function" && !window._origOnBuyNowClick) {
      window._origOnBuyNowClick = window.onBuyNowClick;
      window.onBuyNowClick = function(btn, flag, items) {

        /* Read variant from the form */
        var form = btn ? btn.closest("form") : null;
        var idInput = form ? form.querySelector('[name="id"]') : null;
        var variantId = idInput ? idInput.value : null;
        var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        if (variantId) {
          var freebieItems = getFreebieItemsForProduct(variantId, quantity);

          if (freebieItems.length > 0) {
            /* Build items: product + freebies */
            var productItem = { id: parseInt(variantId), quantity: quantity, properties: {} };
            var allItems = [productItem].concat(freebieItems);
            window._origOnBuyNowClick.call(this, btn, false, allItems);
            return;
          }
        }

        /* No freebies or can't determine variant — proceed normally */
        window._origOnBuyNowClick.call(this, btn, flag, items);
      };
      clearInterval(_checkBuyNow);
    }
  }, 500);

  /* Intercept Gokwik onCheckoutClick — dual-layer freebie injection */
  var _checkCheckout = setInterval(function() {
    if (typeof window.onCheckoutClick === "function" && !window._origOnCheckoutClick) {
      window._origOnCheckoutClick = window.onCheckoutClick;
      window.onCheckoutClick = function() {
        var args = arguments;
        var self = this;

        /* Layer 2: Patch XMLHttpRequest so GoKwik's /cart.js read includes freebies.
           This fires once for the next GET /cart.js, then auto-removes itself. */
        var _origXHROpen = XMLHttpRequest.prototype.open;
        var _origXHRSend = XMLHttpRequest.prototype.send;
        var _patched = false;

        XMLHttpRequest.prototype.open = function(method, url) {
          this._gkFreebieUrl = (typeof url === "string" && method === "GET" && url.indexOf("/cart.js") !== -1) ? url : null;
          return _origXHROpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function() {
          if (this._gkFreebieUrl && !_patched) {
            _patched = true;
            var xhr = this;
            var _origOnLoad = xhr.onload;
            xhr.onload = function() {
              try {
                var cart = JSON.parse(xhr.responseText);
                var missing = getFreebieItemsForCart(cart);
                if (missing.length > 0) {
                  cart.items = cart.items.concat(missing);
                  cart.item_count = (cart.item_count || 0) + missing.length;
                  Object.defineProperty(xhr, "responseText", { value: JSON.stringify(cart), writable: true, configurable: true });
                  Object.defineProperty(xhr, "response", { value: JSON.stringify(cart), writable: true, configurable: true });
                }
              } catch(e) {
                console.error("devx-cartx: freebie XHR patch error", e);
              }
              /* Restore original XHR prototypes immediately */
              XMLHttpRequest.prototype.open = _origXHROpen;
              XMLHttpRequest.prototype.send = _origXHRSend;
              if (typeof _origOnLoad === "function") _origOnLoad.apply(this, arguments);
            };
          }
          return _origXHRSend.apply(this, arguments);
        };

        /* Auto-restore XHR prototypes after 5s safety net (in case GoKwik doesn't fire) */
        setTimeout(function() {
          XMLHttpRequest.prototype.open = _origXHROpen;
          XMLHttpRequest.prototype.send = _origXHRSend;
        }, 5000);

        /* Layer 1 (existing): also add freebies to Shopify cart as belt */
        ensureFreebiesInCart().then(function() {
          window._origOnCheckoutClick.apply(self, args);
        }).catch(function() {
          window._origOnCheckoutClick.apply(self, args);
        });
      };
      clearInterval(_checkCheckout);
    }
  }, 500);

  /* Auto-clear intervals after 30s if Gokwik not loaded (increased from 10s for slow mobile connections) */
  setTimeout(function() { clearInterval(_checkBuyNow); clearInterval(_checkCheckout); }, 30000);
})();

function cartConfetti() {

  var animation = lottie.loadAnimation({
      container: document.getElementById('cartx-confetti'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: 'https://cdn.shopify.com/s/files/1/0633/2183/3679/files/Main_Scene.json?v=1746784652'
  });

  showMessage('Coupon Applied Successfully!', false);
  animation.goToAndStop(0, true);
  animation.play();

  animation.addEventListener('complete', function() {
      animation.destroy();
      document.getElementById('cartx-confetti').innerHTML = '';
  });
}